<template>
  <v-popover v-if="!added">
    <button class="btn btn-block"><i class="fa fa-plus" aria-hidden="true"></i></button>
    <template slot="popover">
      <p v-html="$t('message.add_to_favorites_html')"></p>
      <p>{{ $t("message.add_to_favorites_text") }}</p>
      <button class="btn btn-primary btn-block btn-sm" v-close-popover @click="add_to_storage()">{{ $t("message.add_to_favorites") }}</button>
      <button class="btn btn-link btn-block btn-sm" v-close-popover>{{ $t("message.close") }}</button>
    </template>
  </v-popover>
  <v-popover v-else>
    <button class="btn btn-block"><i class="fa fa-minus" aria-hidden="true"></i></button>
    <template slot="popover">
      <p v-html="$t('message.delete_from_favorites_text')"></p>
      <button class="btn btn-danger btn-block btn-sm" v-close-popover @click="delete_from_storage()">{{ $t("message.delete") }}</button>
      <button class="btn btn-link btn-block btn-sm" v-close-popover>{{ $t("message.close") }}</button>
    </template>
  </v-popover>    
</template>

<script>
export default {
  data () {
    return {
      msg: 'StoragePopover',
    }
  },
  props: {
    category: {
      type: Object,
      required: true
    }
  }, 
  methods: {
    add_to_storage() {
      this.$store.dispatch('pricelist/add_to_storage', this.category);
    },
    delete_from_storage() {
      this.$store.dispatch('pricelist/delete_from_storage', this.category);
      if(this.items.length === 0 && this.is_storage) {
        this.$store.dispatch('pricelist/switch_to_all');
      }
    },
  },
  computed: {
    added() {
      let result = this.$store.getters['pricelist/storage'].map(item => item.id).indexOf(this.category.id);
      return (result === -1) ? false : true;
    },
    items() {
      return this.$store.getters['pricelist/storage'];
    },
    is_storage() {
      return this.$store.getters['pricelist/is_storage'];
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.trigger {
  padding: 7px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/Category/StoragePopover.vue